import { css } from '@emotion/react';
import { IonText } from '@ionic/react';
import React from 'react';
import * as commonCss from '../../styles/common';
import { MeasurementSeries } from '../../shared/measurements';

interface ChangeInLastHourProps {
  data: MeasurementSeries;
}

export const ChangeInLastHour: React.FC<ChangeInLastHourProps> = ({ data }) => {
  const { trendValue, comparisonGapHours, trendStatus } = data.trend;
  let trendText, trendColor, comparisonPreposition;
  switch (trendStatus) {
    case 'data-gap-too-wide':
      // Show nothing if the gap is too wide
      return null;
    case 'invalid':
      // Show nothing if the data is invalid
      return null;
    case 'no-recent-data':
      trendText = 'No recent data';
      comparisonPreposition = '';
      trendColor = 'medium';
      break;
    case 'rising':
      trendText = `▲ ${Math.abs(trendValue)}% worse`;
      comparisonPreposition = 'than';
      trendColor = 'trend';
      break;
    case 'falling':
      trendText = `▼ ${Math.abs(trendValue)}% better`;
      comparisonPreposition = 'than';
      trendColor = 'trend';
      break;
    case 'flat':
      trendText = '■ Same';
      comparisonPreposition = 'as';
      trendColor = 'trend';
      break;
  }

  let updatedHourText;
  if (comparisonGapHours === 0) {
    updatedHourText = '';
  } else if (comparisonGapHours === 1) {
    updatedHourText = 'previous hour';
  } else {
    updatedHourText = `${comparisonGapHours} hours before`;
  }

  const trendComparisonText = `${comparisonPreposition} ${updatedHourText}`.trim();
  const changeInLastHourCss = {
    trendText: [commonCss.smallText, commonCss.bold],
    trendComparisonText: [commonCss.smallText, commonCss.italics, css({ marginLeft: '0.25rem' })],
  };

  return (
    <>
      <IonText color={trendColor} css={changeInLastHourCss.trendText}>
        {trendText}
      </IonText>
      <IonText css={changeInLastHourCss.trendComparisonText}>{trendComparisonText}</IonText>
    </>
  );
};

export default ChangeInLastHour;
